import type { DraggableLocation } from '@hello-pangea/dnd';

import { createContext, use } from 'react';

export type TDragContext = { destination: DraggableLocation | null; source: DraggableLocation | null };
export const DragContext = createContext<TDragContext>({ source: null, destination: null });

export const useDragContext = () => use(DragContext);
